export default __webpack_public_path__ + "static/media/hydarulic_breaker.3502037a.jpg";